import { SortStowageColumnEnum } from 'src/enums/stowage/sortStowageColumnEnum';
import { ColumnWidths } from 'src/types/ViewModel/Stowage/ColumnWidths';
import { getColumnConfigBySortEnum, operationListColumnConfigs } from './columnConfig';

// Generate default column flex values from the column configurations
export const getDefaultColumnWidths = (): ColumnWidths => {
    const widths: ColumnWidths = {};
    operationListColumnConfigs.forEach((column) => {
        widths[column.id] = column.defaultFlex;
    });
    return widths;
};

export const getSavedColumnWidths = (): ColumnWidths => {
    try {
        const savedWidths = localStorage.getItem('operationListColumnWidths');
        if (!savedWidths) return getDefaultColumnWidths();

        const parsedWidths = JSON.parse(savedWidths);
        const defaultWidths = getDefaultColumnWidths();

        // Validate the flex values to ensure they are valid
        Object.keys(parsedWidths).forEach((key) => {
            if (typeof parsedWidths[key] !== 'string' || (!parsedWidths[key].endsWith('px') && !parsedWidths[key].match(/^\d+$/))) {
                console.warn(`Invalid column flex value for ${key}: ${parsedWidths[key]}, using default`);
                parsedWidths[key] = defaultWidths[key] || '100';
            }
        });

        // Ensure we have all default keys (in case new columns were added)
        return { ...defaultWidths, ...parsedWidths };
    } catch (e) {
        console.error('Failed to parse saved column widths:', e);
        localStorage.removeItem('operationListColumnWidths');
        return getDefaultColumnWidths();
    }
};

export const saveColumnWidths = (widths: ColumnWidths): void => {
    try {
        localStorage.setItem('operationListColumnWidths', JSON.stringify(widths));
    } catch (e) {
        console.error('Failed to save column widths:', e);
    }
};

export const resetColumnWidths = (): ColumnWidths => {
    localStorage.removeItem('operationListColumnWidths');
    return getDefaultColumnWidths();
};

export const getColumnNameFromSortEnum = (sortEnum: SortStowageColumnEnum): string => {
    const config = getColumnConfigBySortEnum(sortEnum);
    return config?.id || '';
};
